export default "__VITE_ASSET__0f643a6d__"